import { combineReducers } from 'redux'
import config, { ConfigOptions } from './config'

import organization from 'screens/Organization/state'

export type BoardingReduxState = {
  config: ConfigOptions
  organization: {
    create: unknown
    join: unknown
    accept: unknown
  }
}

export default combineReducers({
  config,
  organization,
})
